<template>
   <div class="app-main">
    <!-- 顶部 -->
    <el-row type="flex" class="app-main-header" align="middle">
      <!-- 页面title -->
			<el-col :span="6">
				<div class="router-title">
					<i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{ $route.meta.title }}</span>
				</div>
			</el-col>
       <!-- 批量操作 -->
			<el-col :span="18" class="app-main-header-btns"> </el-col>
    </el-row>
    <el-row class="mg-b5">
            <el-card class="box-card">
                <!-- 顶部搜索 -->
                <!-- <div slot="header" class="clearfix">
                  <el-form :inline="true" class="demo-form-inline">
                    <el-form-item class="my-form-item">
                      <el-input size="mini" placeholder="流程模型名称" clearable v-model="quertInfo.objMap.search" style="width: 250px" prefix-icon="el-icon-search"></el-input>
                    </el-form-item>
                    <el-form-item class="my-form-item">
                      <el-button size="mini" type="primary" @click="onSearch" >查询 </el-button>
                    </el-form-item>
                  </el-form>
                </div> -->
                <div>
                  <el-button size="mini"  type="primary" @click="handleAdd"> 新建模型 </el-button>
                </div>
                <div class="table-box">
                    <!-- 表格 -->
                    <el-table :data="tableData" border size="mini" >
                        <!-- <el-table-column type="selection" width="40" align="left"> </el-table-column> -->
                        <el-table-column prop="id" label="模型id" :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column prop="name" label="模型名称" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="key" label="模型key" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="revision" label="版本" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column prop="metaInfo" label="备注描述" :show-overflow-tooltip="true"> </el-table-column>
                        <el-table-column prop="createTime" label="创建时间" :show-overflow-tooltip="true"> </el-table-column>
                         <el-table-column prop="lastUpdateTime" label="最后更新时间" :show-overflow-tooltip="true" width="120"> </el-table-column>
                        <el-table-column label="操作" width="120" align="left" fixed="right">
                            <template slot-scope="scope">
                              <el-button type="text" size="small"  @click="">发布</el-button>&nbsp;
                                <el-button type="text" size="small"  @click="updatelc(scope.row.id)">设计流程</el-button>&nbsp;
                                <el-link class="el-link-s" target='_blank'  @click="handleDel(scope.row.id)" type="primary">删除</el-link>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-card>
      </el-row>
      <el-dialog :visible.sync="openDialog" width="600px" :title="title">
        <el-form label-width="80px" ref="form" :model="form" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item label="模型名称" prop="name">
                <el-input v-model="form.name" placeholder="请输入模型名称" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="模型key" prop="code">
                <el-input v-model="form.key" placeholder="请输入模型key" />
              </el-form-item>
            </el-col>
        
          </el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="createObjOk">确 定</el-button>
				<el-button @click="openDialog = false">取 消</el-button>
			</span>
		</el-dialog>
    <el-dialog :visible.sync="iframDialog" width="900px" >
      <iframe  :src="iframUrl" frameborder="0" width="100%" height="800px" scrolling="auto" style="background-color: #fff;"></iframe>
    </el-dialog>
   </div>
</template>

<script>
import { modelListData,deleteModel} from '@/api/activiti/activiti';
export default {
  data() {
    return {
      tableData: [],
      openDialog: false,
      iframDialog:false,
      form: {},
      iframUrl:""
    }
  },
  created() {
        this.getList()
  },
  methods: {
    handleDel:function(id){
      let _this = this;
      _this.confirm({
        text: '确认删除吗',
        tip: '警告',
        type: '',
        fn: function(param) {
          deleteModel(param).then(response => {
            if (response.data.code === 0) {
              _this.$success(response.data.msg);
              _this.getList();
            } else {
              _this.$fail(response.data.msg);
            }
          });
        },
        data: {
          id: id
        } //参数对象 主要回调函数用
      });
      },
    updatelc(obj) {
      this.iframUrl = `http://localhost:8888/activiti/modeler.html?modelId=${obj||""}`;
      this.iframDialog = true
    },
    createObjOk(e) {
      this.iframDialog = true
      this.iframUrl = `http://localhost:8888/activiti/models/create?name=${this.form.name||""}&key=${this.form.key||""}&description=${""||""}`
    },
    handleAdd: function() {
				this.title = "新增流程模型";
				this.openDialog = true;
			},
    onSearch(){
          this.getList();
      },
    async getList() {
            let _this = this;
            const {
                data: res
            } = await modelListData(_this.quertInfo)
            console.log('1111111',res)
            if (res.code == 0) {
                _this.tableData = res.data;
                _this.count = res.count;
            }
        },
  }
}



</script>